export const openCarousel = (images, startIndex) => {
  const popupWindow = window.open('', '_blank', 'resizable=yes,scrollbars=yes');

  popupWindow.document.write(`
    <html>
    <head>
      <title>Image Carousel</title>
      <style>
        body, html { margin: 0; padding: 0; width: 100%; height: 100%; overflow: auto; }
        img { width: auto; max-width: 100%; height: auto; display: block; min-width: 300px; }
        #nav { position: absolute; width: 100%; bottom: 10px; text-align: center; }
        .button { cursor: pointer; padding: 10px; font-size: 16px; background: #ddd; border: none; }
      </style>
    </head>
    <body>
      <div id="content"></div>
      <div id="nav">
        <button onclick="prev()" class="button">Prev</button>
        <button onclick="next()" class="button">Next</button>
      </div>
    </body>
    </html>
  `);

  function updateWindowSize(imageWidth, imageHeight) {
    const adjustedWidth = Math.max(imageWidth, 300);
    popupWindow.resizeTo(adjustedWidth, imageHeight + 100);
  }

  function showMedia(index) {
    const media = images[index];
    const image = new Image();
    image.src = media.url;
    image.onload = function() {
      updateWindowSize(this.width, this.height);
      popupWindow.document.getElementById('content').innerHTML = '<img src="' + this.src + '" alt="Image">';
    };
  }

  const initialImage = new Image();
  initialImage.src = images[startIndex].url;
  initialImage.onload = function() {
    updateWindowSize(this.width, this.height);
    showMedia(startIndex);
  };

  popupWindow.prev = function() {
    startIndex = (startIndex - 1 + images.length) % images.length;
    showMedia(startIndex);
  };

  popupWindow.next = function() {
    startIndex = (startIndex + 1) % images.length;
    showMedia(startIndex);
  };

  // Adding functions to popupWindow for accessing from HTML buttons
  popupWindow.document.getElementById('nav').children[0].onclick = function() { popupWindow.prev(); };
  popupWindow.document.getElementById('nav').children[1].onclick = function() { popupWindow.next(); };
};
